import { Sentry } from '@sonnen/web-utils';
import { AuthenticationProvider } from '@sonnen/web-utils/components';
import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppContextProvider } from './AppContext/AppContext';
import { useTranslation } from './i18n/i18n';
import { getDefaultLocale, getRedirectUri } from './utils/utils';

const element = document.getElementById('root');
const root = ReactDOM.createRoot(element!);

const Main = () => {
  const apiUrl = import.meta.env.VITE_AUTH_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH_CLIENT_ID;

  const { changeLanguage } = useTranslation();

  if (!apiUrl || !clientId) {
    throw new Error(
      `Missing required environment variables VITE_AUTH_DOMAIN and VITE_AUTH_CLIENT_ID: ${apiUrl}, ${clientId}`,
    );
  }

  const redirectUri = useMemo(() => getRedirectUri(), []);

  const authConfig = {
    autoLogin: false,
    apiUrl,
    clientId,
    redirectUri,
    scope: 'openid',
  };

  const instantiateSentry = () => {
    const appEnv = process.env.VITE_ENV;
    const sentryDns = process.env.VITE_SENTRY_DSN;
    if (appEnv && sentryDns) new Sentry(appEnv, sentryDns);
  };

  useEffect(() => {
    if (localStorage.getItem('tariff:cookieConsent')) {
      /* Before integrating usercentrics as cookie consent manager,
       * we used a custom-made cookie consent solution
       * that stored the consent in localStorage under the key 'tariff:cookieConsent'.
       * This key is no longer used, so if the key exists, we remove it
       * from user's browser to avoid confusion.
       */
      localStorage.removeItem('tariff:cookieConsent');
    }

    changeLanguage(getDefaultLocale());
    instantiateSentry();
  }, []);

  return (
    <React.StrictMode>
      <AuthenticationProvider config={authConfig}>
        <AppContextProvider>
          <BrowserRouter basename={process.env.VITE_URL_BASE_PATH || '/'}>
            <App />
          </BrowserRouter>
        </AppContextProvider>
      </AuthenticationProvider>
    </React.StrictMode>
  );
};

root.render(<Main />);
